import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import logo from '../assests/img/logo.png';
import { NavLink, Link } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet-async';

export default function Aijebookingform() {
  return (
    <div>
      <Helmet>
        <title>AIJE 2026 – India’s Premier Gem & Jewellery B2B Exhibition | Aadikaash</title>
        <meta
          name="description"
          content="AIJE 2026 – India’s leading gem & jewellery B2B trade show. Connect with top jewellery manufacturers, exporters, and buyers in Mumbai, India."
        />
        <meta
          name="keywords"
          content="AIJE 2026, jewellery exhibition India, gem and jewellery B2B, jewellery trade show, Indian jewellery exporters, jewellery suppliers Mumbai"
        />
      </Helmet>

      <Header />
      <iframe src="https://aadikaash.com/backend/aije-booking-form/" className='iframe-box'></iframe>
      <Footer/>
    </div>
  )
}
